import * as Styled from './pop-over.styles';
import type { PopOverPrimitiveProps } from './pop-over.types';

export const PopOverPrimitive: React.FC<PopOverPrimitiveProps> = ({
  children,
  className,
  containerRef,
  onClose,
  position,
  showCloseButton,
  ...props
}) => (
  <Styled.Wrapper
    className={className}
    data-xds="PopOver"
    ref={containerRef}
    style={{ ...position }}
    tabIndex={-1}
    {...props}
  >
    {showCloseButton && <Styled.CloseButton onClick={onClose} size="large" />}
    {children}
  </Styled.Wrapper>
);

PopOverPrimitive.displayName = 'PopOver (Primitive)';
